/** @const {!Array<{value: string, label: string}>} */
export const CLOSE_REASON_OPTIONS = [
  { value: "complete", label: "Complete" },
  { value: "supplier_short_shipped", label: "Supplier short-shipped" },
  { value: "discontinued", label: "Discontinued" },
  { value: "no_longer_needed", label: "No longer needed" },
  { value: "written_off", label: "Written off" },
  { value: "other", label: "Other" },
];

/**
 * Must match PurchaseOrderReopenReasonChoices and ConsignmentReopenReasonChoices.
 *
 * @const {!Array<{value: string, label: string}>}
 */
export const REOPEN_REASON_OPTIONS = [
  { value: "closed_by_mistake", label: "Closed by mistake" },
  { value: "more_items_expected", label: "More items expected" },
  { value: "receipt_correction", label: "Receipt needs correcting" },
  { value: "billing_correction", label: "Billing needs correcting" },
  { value: "other", label: "Other" },
];
